"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.R = void 0;
const Leaf = __importStar(require("leaf-ts"));
var R;
(function (R) {
    var _a;
    let WidgetCompileInfo;
    if (typeof NO_COMPILE_INFO === "undefined" || !NO_COMPILE_INFO) {
        WidgetCompileInfo = {
            "project": "/dev/shm/VersetProduction/verset-webapp.release/prod-497674fb-c4e34b12612d",
            "path": "src/script/probeHint/probeHint.theme/business/probeHint.html",
            "namespace": "R",
            "created": "2026-11-01 23:50:06"
        };
    }
    class ProbeHint extends Leaf.GeneratedWidget {
        static { _a = Leaf.CompileInfoSymbol; }
        constructor() {
            super(Leaf.WidgetThemeCenter.getThemeGenerator(ProbeHint), "ProbeHint", []);
            this.TestDatas = ProbeHint.TestDatas;
            this.BindedLists = ProbeHint.BindedLists;
            this.BindedWidgets = ProbeHint.BindedWidgets;
            this.InitialData = ProbeHint.InitialData;
            this.path = ProbeHint.path;
            this.GeneratedConstructor = ProbeHint;
            if (ProbeHint.InitialData) {
                this.renderRecursive(ProbeHint.InitialData);
            }
        }
        static { this[_a] = WidgetCompileInfo && {
            ...WidgetCompileInfo,
            namespace: "R.ProbeHint",
        }; }
        static { this.generator = function () {
            var _e = this._e.bind(this);
            var _t = this._t.bind(this);
            return _e("div", { "data-theme": { "name": "data-theme", "templates": [{ "type": "raw", "content": "business" }] }, "class": { "name": "class", "templates": [{ "type": "raw", "content": "probe-hint-e783e1 business-sticky-notice-layout" }] } }, [_t({ "templates": [{ "type": "raw", "content": "\n    " }] }), _e("div", { "class": { "name": "class", "templates": [{ "type": "raw", "content": "business-sticky-notice-context" }] } }, [_t({ "templates": [{ "type": "raw", "content": "Local access" }] })]), _t({ "templates": [{ "type": "raw", "content": "\n    " }] }), _e("div", { "class": { "name": "class", "templates": [{ "type": "raw", "content": "business-sticky-notice-message" }] } }, [_t({ "templates": [{ "type": "raw", "content": "Connect a computer to use files and terminal tools from this workspace." }] })]), _t({ "templates": [{ "type": "raw", "content": "\n    " }] }), _e("div", { "class": { "name": "class", "templates": [{ "type": "raw", "content": "business-sticky-notice-actions" }] } }, [_t({ "templates": [{ "type": "raw", "content": "\n        " }] }), _e("button", { "type": { "name": "type", "templates": [{ "type": "raw", "content": "button" }] }, "class": { "name": "class", "templates": [{ "type": "raw", "content": "business-action-button business-action-button-quiet business-sticky-notice-action" }] }, "data-id": { "name": "data-id", "templates": [{ "type": "raw", "content": "openGuide" }] } }, [_t({ "templates": [{ "type": "raw", "content": "Connect computer" }] })]), _t({ "templates": [{ "type": "raw", "content": "\n    " }] })]), _t({ "templates": [{ "type": "raw", "content": "\n" }] })]);
        }; }
        static { this.TestDatas = []; }
        static { this.BindedLists = []; }
        static { this.BindedWidgets = []; }
        static { this.path = "/script/probeHint/probeHint.theme/business/probeHint"; }
        static { this.widgetName = "ProbeHint"; }
        static { this.InitialData = null; }
    }
    R.ProbeHint = ProbeHint;
    ProbeHint["prototype"].widgetName = "ProbeHint";
})(R || (exports.R = R = {}));
if (typeof NO_LESS_IN_SOURCE === "undefined" || !NO_LESS_IN_SOURCE) {
    const lessContent = "\n.probe-hint-e783e1 {\n\n    & {\n        display: flex;\n        flex-direction: column;\n        gap: 4px;\n        min-width: 0;\n    }\n\n    .business-sticky-notice-context {\n        color: #8a847c;\n        font-size: 11px;\n        font-weight: 300;\n        line-height: 1.4;\n    }\n\n    .business-sticky-notice-message {\n        color: #272522;\n        font-size: 12px;\n        font-weight: 400;\n        line-height: 1.5;\n    }\n\n    .business-sticky-notice-actions {\n        display: flex;\n        flex-wrap: wrap;\n        align-items: center;\n        gap: 4px;\n        margin-top: 4px;\n    }\n\n    .business-sticky-notice-action {\n        display: inline-flex;\n        align-items: center;\n        justify-content: center;\n        box-sizing: border-box;\n        min-width: auto;\n        height: 26px;\n        padding: 0 7px;\n        border: 1px solid transparent;\n        border-radius: 3px;\n        background: transparent;\n        color: #6b6761;\n        cursor: pointer;\n        font: inherit;\n        font-size: 12px;\n        font-weight: 400;\n        line-height: 1;\n    }\n\n    .business-sticky-notice-action:hover {\n        background: #f4f3f1;\n        color: #272522;\n    }\n\n    .business-sticky-notice-action:focus-visible {\n        outline: 2px solid #bcb6ae;\n        outline-offset: 2px;\n    }\n\n\n}\n\n";
    const _global = globalThis;
    _global.lesses = _global.lesses || [];
    _global.lesses.push({ filename: __filename, less: lessContent });
}
